export default __webpack_public_path__ + "static/studio3-0d079dd0bb1452ef0f9bc6e41479e927.png";